import React from 'react';

import { connect } from 'react-redux';

import withLoyaltyAccess from '@/hocs/withLoyaltyAccess';
import { useTranslation } from '@/i18n';
import { PointSystemPropsType } from '@/models/customerAdvocacyModels';
import { ServerStatus } from '@/models/globalModels';
import { doSetCustomerAdvocacyPoints } from '@/redux/customerAdvocacy/actions';
import { selectPointSystemData } from '@/redux/customerAdvocacy/reducers';
import { RootState } from '@/redux/rootReducer';

const mapDispatchToProps = {
  doSetCustomerAdvocacyPoints,
};

const mapStateToProps = (state: RootState) => {
  const auth = state.auth;
  return {
    pointsInfo: selectPointSystemData(state),
    ambassadorStatus: auth.ambassadorStatus,
  };
};

const CustomerAdvocacyPointSystem = ({
  pointsInfo,
  ambassadorStatus = ServerStatus.IDLE,
  doSetCustomerAdvocacyPoints,
}: PointSystemPropsType) => {
  const { t } = useTranslation('dashboard');

  const calculateBarProgress = (tierEnd: number, tierEarned: number): string => {
    if (!tierEnd || !tierEarned) return '0%';
    const progress = (tierEarned / tierEnd) * 100;
    if (progress > 100) return '100%';
    return progress.toString() + '%';
  };

  const barProgress = calculateBarProgress(pointsInfo.loyalty_points_tier_end, pointsInfo.loyalty_points_earned);

  const currentTier = pointsInfo?.loyalty_points_current_tier;
  const nextTier = pointsInfo?.loyalty_points_next_tier;

  const pointsToNextTier = (pointsInfo.loyalty_points_tier_end - pointsInfo.loyalty_points_earned).toLocaleString();

  const progressBarStyle: React.CSSProperties = {
    width: barProgress,
  };

  React.useEffect(() => {
    if (ambassadorStatus === ServerStatus.FETCH && pointsInfo) {
      doSetCustomerAdvocacyPoints(pointsInfo);
    }
  }, [ambassadorStatus, doSetCustomerAdvocacyPoints]);

  if (pointsInfo.loyalty_points_tier_end === 0) {
    return null;
  }

  return (
    <div className="pointSystem">
      <div className="align-items-center justify-content-center">
        <div className="pointSystemWrapper mt-3 f-raleway-regular">
          {false && (
            <>
              <h4 className="f-14 fw-500 lh-17 text-center">{t('sidebar.pointsEarned')}</h4>
              <h3 className="lh-17 text-center f-16 fw-600 f-roboto-regular">{pointsInfo?.loyalty_points_earned?.toLocaleString()}</h3>
            </>
          )}
          <div className="pointsGraphWrapper text-center align-items-center m-auto">
            <div className="pointsGraph mx-auto">
              <div className="progressBar" style={progressBarStyle} />
            </div>
            <div className="graphLabels d-flex">
              {currentTier ? (
                <div className="graphLevelLabel ps-1 pt-1 f-roboto-extraBold f-10 d-flex align-items-center">
                  <span className="graphLevelIcon icon-star pe-1 rotate" />
                  <span style={{ color: currentTier?.color }}>{currentTier?.name}</span>
                </div>
              ) : null}
              {nextTier ? (
                <div className="d-flex flex-column w-100">
                  <div className="graphNextLevel f-12 f-roboto-regular d-flex flex-row-reverse pe-2 pt-1 w-100 lh-15">
                    <span>{nextTier?.name}</span>
                  </div>
                  <p className="pointsLeftNextTier f-9 f-roboto-regular d-flex flex-row-reverse pe-2 pt-1 w-100 lh-15">
                    {t('sidebar.pointsLeft', { points: pointsToNextTier })}
                  </p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(withLoyaltyAccess(CustomerAdvocacyPointSystem));
